import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import * as m from "~/paraglide/messages";
import { orpc } from "~/lib/orpc-client";

/* ── Sidebar credit balance indicator ── */

export function SidebarCreditBalance() {
  const creditQuery = useQuery(orpc.credits.getBalance.queryOptions());
  const data = creditQuery.data;

  if (!data || data.limit <= 0) return null;

  const pct = Math.min((data.balance / data.limit) * 100, 100);
  const isLow = pct < 20 && pct > 0;
  const isExhausted = data.balance <= 0;

  return (
    <div className="px-3 py-2" data-testid="sidebar-credit-balance">
      <div className="flex items-center justify-between text-xs" style={{ color: "var(--text-muted)" }}>
        <span>{m.sidebar_credits_label()}</span>
        <span className="font-medium mono tabular" style={{ color: isExhausted ? "var(--error)" : isLow ? "var(--warning)" : "var(--text-secondary)" }}>
          {data.balance}/{data.limit}
        </span>
      </div>
      <div
        className="mt-1.5 h-1.5 w-full rounded-full overflow-hidden"
        style={{ background: "var(--bg-secondary)" }}
        role="progressbar"
        aria-valuenow={data.balance}
        aria-valuemin={0}
        aria-valuemax={data.limit}
        aria-label={`${m.sidebar_credits_label()}: ${data.balance} / ${data.limit}`}
      >
        <div
          className="h-1.5 rounded-full"
          style={{
            width: "100%",
            background: isExhausted ? "var(--error)" : isLow ? "var(--warning)" : "var(--accent)",
            transform: `scaleX(${pct / 100})`,
            transformOrigin: "left",
            transition: "transform 500ms var(--ease-out)",
          }}
        />
      </div>
      {(isLow || isExhausted) && (
        <Link to="/pricing" className="mt-1.5 block text-xs font-medium" style={{ color: isExhausted ? "var(--error)" : "var(--warning)" }}>
          {m.sidebar_credits_upgrade()}
        </Link>
      )}
    </div>
  );
}
